import React from "react";
import { Button, message, Modal } from "antd";
import { observer } from "mobx-react-lite";
import OrderDTO from "@/dto/order/OrderDTO";
import ShopDTO from "@/dto/shop/ShopDTO";
import { cancelManualOrder } from "@/services/api/order";
import OrderTab from "../../enum/OrderTab";
import { useOrderManagementStore } from "../../store/OrderManagementStore";

interface CancelOrderButtonProps {
    getSelectedOrders(): OrderDTO[];

    shop: ShopDTO;

    tab: OrderTab;
}

const CancelOrderButton: React.FC<CancelOrderButtonProps> = function (props) {
    const { shop, tab } = props;

    const orderManagementStore = useOrderManagementStore();

    return (
        <Button
            type="primary"
            danger
            className="fr"
            onClick={() => {
                Modal.confirm({
                    title: "确认取消选中的订单吗？",
                    content: "温馨提示：请核实确认后再进行取消操作避免误取消",
                    async onOk() {
                        const orders = orderManagementStore.table.selectedOrders;

                        if (!orders.length) {
                            Modal.error({
                                title: "请先至少选择一个订单",
                            });
                            return;
                        }

                        const orderIds = orders.map(({ id }) => id);

                        const shopId = orders[0].shopId;

                        await cancelManualOrder({ orderIds, shopId });

                        message.success("订单取消成功");

                        orderManagementStore.fetchOrders(shop.id, tab);

                        orderManagementStore.getOrderListCount();
                    },
                });
            }}
        >
            取消订单
        </Button>
    );
};

export default observer(CancelOrderButton);
